import { Message } from 'element-ui';
import { HS_upload } from './huoshanUpload';
import { customAlphabet } from 'nanoid';
const nanoid = customAlphabet('abcdefghijklmnopqrstuvwxyz1234567890', 32);
let _this;

tinymce.PluginManager.add('uploadAudio', function (editor, url) {
    editor.ui.registry.addIcon(
        "audio-icon",
        `<svg fill="none" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="design-iconfont"><mask id="dhg2hlpgp__277z7lv3ea" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><path fill="#D9D9D9" d="M0 0H24V24H0z"/></mask><g mask="url(#dhg2hlpgp__277z7lv3ea)" stroke="#333" stroke-width="1.5"><path fill="none" d="M18.75 15.75V3L7.5 5.25V16.5"/><path fill="none" d="M7.5 9.75L18.75 7.5"/><path fill="none" d="M3 18C3 17.1716 3.67157 16.5 4.5 16.5H7.5V18C7.5 18.8284 6.82843 19.5 6 19.5H4.5C3.67157 19.5 3 18.8284 3 18V18Z"/><path fill="none" d="M14.25 16.5C14.25 15.6716 14.9216 15 15.75 15H18.75V16.5C18.75 17.3284 18.0784 18 17.25 18H15.75C14.9216 18 14.25 17.3284 14.25 16.5V16.5Z"/></g></svg>`
    );

    // 注册一个工具栏按钮名称
    editor.ui.registry.addButton('uploadAudio', {
        icon: `audio-icon`,
        tooltip: '插入音频',
        onAction: function () {
            let doc = editor.getDoc();
            if (doc.getElementsByTagName("dd-audio").length > 0) {
                Message.error("音频文件只允许添加一次，请删除后再添加");
                return;
            }
            var input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "audio/*");
            input.click();
            input.onchange = function (e) {
                let file = this.files[0];
                let type = file.type.toLowerCase();
                const isAUDIO = type.indexOf("audio/") >= 0 && (type.indexOf("mp3") >= 0 || type.indexOf("wav") >= 0 || type.indexOf("ogg") >= 0 || type.indexOf("mpeg") >= 0);
                if (!isAUDIO) {
                    Message.error("请上传符合规格的音频格式！");
                } else {
                    const nanoidGet = nanoid(32);
                    editor.insertContent(`<div class="get-cover" contenteditable="false" data-nanoid="${nanoidGet}" data-originId="" id="" style="height: 102px;min-height: 103px;"><div class="videoProcessContain" style="margin-top: -20px;display: none;"><div class="videoProcess"></div></div><div class="tip">音频上传中...</div></div>`);

                    cosUploadFile(file, (fileUrl, nanoidFinish) => {
                        let videoItems = document.getElementsByClassName("get-cover");
                        videoItems = Array.from(videoItems);
                        videoItems.forEach((item1) => {
                            if (item1.getAttribute("data-nanoid") == nanoidFinish) {
                                item1.outerHTML = `<dd-audio contenteditable="false" style="margin-top: 15px;" src="${fileUrl}" title="${file.name.split('.').slice(0, -1).join('.')}"></dd-audio>`;
                            }
                        });

                        //editor.insertContent(`<dd-audio contenteditable="false" style="margin-top: 15px;" src="${fileUrl}" title="${file.name.split(".")[0]}"></dd-audio>`);
                    }, nanoidGet);
                }
            };
        }
    });

    return {
        getMetadata: function () {
            return {
                //插件名和链接会显示在“帮助”→“插件”→“已安装的插件”中
                name: "",//插件名称
                url: "", //作者网址
            };
        }
    };
});

function cosUploadFile(file, callback, nanoid) {
    HS_upload(file, (data) => {
        _this.progressPercentArray[nanoid] = 100;
        callback(data.url, nanoid);
    },
        (error) => {
            console.log("error:" + error);
        }, (processPercent) => {
            console.log("processPercent:" + processPercent);
            if (!_this.progressPercentArray[nanoid]) {
                _this.$set(_this.progressPercentArray, nanoid, 0);
            }
            _this.progressPercentArray[nanoid] = Math.floor(processPercent);
        })
};

export default function map_callback_audio(self) {
    _this = self;
};